import { css } from "styled-components"

export const LARGE_BUTTON_BORDER_RADIUS = "36px"
export const XL_BUTTON_BORDER_RADIUS = "30px"
export const XL_BUTTON_PADDING = "50px"
export const BUTTON_HEIGHT = "40px"
export const SMALL_BUTTON_PADDING = "25px"
export const SMALL_BUTTON_BORDER_RADIUS = "20px"

export const COLOR = {
  darkSteelBlue: "#495c74",
  steelBlue: "#688098",
  facebookBlue: "#4565a0",
  darkFacebookBlue: "#2a477c",
  brightBlue: "#3b99fc",
  skyBlue: "#7cd5ff",
  waterBlue: "#146dca",
  veryLightSteelBlue: "#c3cbdf",
  lightDeepBlue: "rgba(59, 153, 252, 0.1)",
  lightShallowBlue: "#00c9e5",

  rentspreeDarkBlue: "#2563AD",
  deepBlueHover: "#007ADF",
  secondary: "#405369",
  lightSecondary: "#546A84",

  brightRoyalBLue: "#4b97f5",
  deepBlue: "#3b99fc",
  deepBluePale: "#E2F0FF",
  deppBlueBtn: "rgb(61,138,247)",
  darkBlue: "#004BB0",
  darkDeepBlue: "rgb(29, 102, 206)",
  veryLightGray: "#f1f1f1",
  lineGray: "#e5e5e5",
  lightGray: "#aaaaaa",
  softGray: '#22222280',
  deepGray: "#5F5F5F",
  gray: "#888888",
  darkGray: "#4a4a4a",
  textBlack: "#333333",
  borderGray: "rgba(0, 0, 0, 0.23)",
  shadowGray: "rgba(0, 0, 0, 0.08)",
  hoverGrey: "rgba(0, 0, 0, 0.1)",

  black: "#000000",
  white: "#ffffff",
  whiteTwo: "#f9f9f9",

  softRed: "#f15555",
  lightSoftRed: "rgba(241, 85, 85, 0.1)",

  green: "#80c640",
  greenPale: "#E6FFCF",
  deepGreen: "#158D31",
  darkGreen: "#67A033",
  springGreen: "#b6f67b",

  darkYellow: "#a7903f",
  darkYellowBrighter: "#AC932D",
  yellow: "#d3b84c",
  yellowPale: "#FEF5D9",
  lightYellow: "#f2d76b",
  silkyYellow: "#e9d230",
  pale: "#fef5d9",
  superDarkGray: "#333333",

  orange: "#ff8a23",

  darkNegativeRed: "#a72f31",
  negativeRed: "#F15555",
  lightRed: "#FF7D7D",

  newGrey: "#E5E5E5",
  bgGrey: "#F1F1F1",
  textGrey: "#888888",
  redPale: "#FFE9E9",
  boxGrey: "#999999",
  disabledGrey: "#EBEBEB",

  secondaryPurple: "#6C00D2"
}

export const BUTTON_SHADOW = "0 15px 20px 0 rgba(0, 0, 0, 0.1)"
export const NORMAL_SHADOW = "0 2px 7px 0 rgba(0, 0, 0, 0.1)"
export const HOVER_SHADOW = "0 2px 15px 0 rgba(0, 0, 0, 0.25)"
export const DROPDOWN_SHADOW = "0 0 20px 0 rgba(0, 0, 0, 0.15)"
export const MODAL_OVERLAY = "rgba(0, 0, 0, 0.5)"
export const SHADOW_LV1 = "0px 2px 10px 0 rgba(0, 37, 112, 0.05)"

export const ANIMATE = {
  FAST: "0.2s",
  NORMAL: "0.5s",
  SLOW: "1s",
}

export const FLEX_CENTER = css`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const INLINE_FLEX_CENTER = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`
